import React from 'react';
import PropTypes from 'prop-types';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import './MapaQuadriculado.css';
import * as api from '~/Services/Service';

var STATUS_CORES = {
  0: '#4CAF50', //Disponível
  1: '#e65f5d', //Vendido
  2: '#333333', //Bloqueado
  3: '#5c6bc0', // PreVenda
  4: '#9e9e9e', // PropostaRapida
  5: '#fb974fff', // Reservado
  6: '#8D6E63 ', // Em Negociação
  7: '#d3d3d3', // Sem precificação
};

var TIPOLOGIAS = {
  1: 'Residencial',
  2: 'Comercial',
  3: 'Vertical',
  4: 'Misto',
};

function agruparPorQuadra(lotes) {
  var grupos = {};
  lotes.forEach(function(lote) {
    var quadra = lote.quadra;
    if (!grupos[quadra]) {
      grupos[quadra] = [];
    }
    grupos[quadra].push(lote);
  });
  return grupos;
}

function ordenarQuadras(quadras) {
  return quadras.sort(function(a, b) {
    var matchA = a.match(/^([A-Z]+)(\d*)$/i);
    var matchB = b.match(/^([A-Z]+)(\d*)$/i);
    if (!matchA || !matchB) return a.localeCompare(b);

    var letraA = matchA[1].toUpperCase();
    var letraB = matchB[1].toUpperCase();
    var numA = matchA[2] ? parseInt(matchA[2], 10) : 0;
    var numB = matchB[2] ? parseInt(matchB[2], 10) : 0;

    if (letraA !== letraB) {
      return letraA.localeCompare(letraB);
    }
    return numA - numB;
  });
}

function ordenarLotes(lotes) {
  return lotes.slice().sort(function(a, b) {
    var numA = parseInt(a.lote, 10) || 0;
    var numB = parseInt(b.lote, 10) || 0;
    return numA - numB;
  });
}

function MapaQuadriculado(props) {
  var lotes = props.lotes || [];
  var onLoteClick = props.onLoteClick;
  var loading = props.loading || false;

  if (!lotes || lotes.length === 0) {
    return (
      <div className="mapa-quadriculado">
        <div className="mapa-vazio">Nenhum lote disponível</div>
      </div>
    );
  }
  if (loading) {
    return (
      <div className="mapa-quadriculado">
        <div className="mapa-vazio">Carregando...</div>
      </div>
    );
  }

  var grupos = agruparPorQuadra(lotes);
  var quadrasOrdenadas = ordenarQuadras(Object.keys(grupos));

  function handleClick(lote) {
    if (onLoteClick) {
      onLoteClick(lote);
    }
  }

  return (
    <div className="mapa-quadriculado">
      {quadrasOrdenadas.map(function(quadra, index) {
        var lotesQuadra = ordenarLotes(grupos[quadra]);

        return (
          <React.Fragment key={quadra}>
            {index > 0 && <hr className="mapa-divisor" />}
            <div className="mapa-linha">
              <div className="quadra-label">{quadra}</div>
              <div className="lotes-container">
                {lotesQuadra.map(function(lote) {
                  var cor = lote.sem_precificacao
                    ? STATUS_CORES[7]
                    : (STATUS_CORES[lote.status] || STATUS_CORES[0]);
                  var loteNumero = lote.lote.toString().padStart(2, '0');

                  return (
                    <OverlayTrigger
                      key={lote.codigo || quadra + '-' + lote.lote}
                      overlay={
                        <Tooltip>{lote.codigo}</Tooltip>
                      }
                    >
                      <div
                        className={
                          'lote-cell' + (lote.tem_casa ? ' lote-cell--casa' : '')
                        }
                        style={{ backgroundColor: cor }}
                        onClick={function() {
                          handleClick(lote);
                        }}
                      >
                        {loteNumero}
                      </div>
                    </OverlayTrigger>
                  );
                })}
              </div>
            </div>
          </React.Fragment>
        );
      })}
    </div>
  );
}

MapaQuadriculado.propTypes = {
  lotes: PropTypes.array.isRequired,
  onLoteClick: PropTypes.func,
};

export default MapaQuadriculado;
